"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  code: 'USD',
  symbol: '$',
  name: 'U.S. Dollar',
  locale: 'en-US',
  isNativeCurrency: true,
  isBookableCurrency: true
});

exports["default"] = _default;